<template functional>
  <div class="search-results">
    <div
      class="container"
      v-on="listeners.touchmove ? { touchmove: listeners.touchmove } : null"
    >
      <div class="content">
        <slot name="content" />
      </div>
    </div>
    <slot name="view-results-button" />
  </div>
</template>

<script>
export default {
  name: 'SearchResults'
}
</script>

<style lang="scss" scoped>
.search-results {
  background-color: $white;
  padding: 5px;

  @include tablet {
    border: 1px solid $grey;
    box-shadow: 0 1px 10px 0 $grey;
    box-sizing: border-box;
  }
}

.container {
  max-height: 45vh;
  min-height: 50px;
  overflow-x: hidden;
  overflow-y: auto;

  @include mobile {
    padding: 15px 10px;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: $grey-light;
    }

    &::-webkit-scrollbar-thumb {
      background: $grey;
    }
  }

  @include tablet {
    padding: 20px 10px;
  }

  @include desktop {
    padding: 20px 30px;
  }

  @include widescreen {
    padding: 20px 35px;
  }
}
</style>
